import type { FaireProductEntity } from "../../entity_types/product";

export const p_2ap4kvz2ms: FaireProductEntity = {
  token: "p_2ap4kvz2ms",
  type: "product",
  name: "Mini Silver Tulip Studs",
  brandToken: "b_exadnf3wpa",
  brandName: "Natalie Clare Collections",
  imageUrl:
    "https://cdn.faire.com/fastly/8bb30fd2bbe1afebb003d1f45722c4d4479bdf720e18f70dc578588be8415434.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/780ab0b1b68e495b781eb42689978c8fa9a0285169e7406ddaf7460e7077ca0d.jpeg",
    "https://cdn.faire.com/fastly/815a3bbceae5dba175cadb68b7b852c13c1ed717411ec6556f6f8beb553f09ba.jpeg",
    "https://cdn.faire.com/fastly/e3e21eeb12a8b1224f4c7fa2ef75000f33862bbd0bd2432b6c693347cf2d4878.jpeg",
  ],
  priceDollars: 11,
  description:
    "Add a touch of flower power to your ear game with these Mini Silver Tulip Studs. Made with 925 sterling silver pins, they're perfect for sensitive ears or second holes. These petite studs are the perfect accessory for any occasion (and won't wilt after a day of wear)!\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:12.990Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
